import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../components/forms/input'
import MyRichText from '../../components/forms/richText'
import MyImageUpload from '../../components/forms/imageUpload'

const AddFitnessSeries = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.title) {
      setErrorMsg({titleEmpty: '健身系列标题不能为空'})
      return false
    }
    if (!formValue.cover_url) {
      setErrorMsg({coverEmpty: '健身系列照片不能为空'})
      return false
    }
    if (!formValue.introduction) {
      setErrorMsg({introductionEmpty: '详细介绍不能为空'})
      return false
    }

    axios.post('/admin/content/fitness_series/add', {
      title: formValue.title,
      introduction: formValue.introduction,
      cover_url: formValue.cover_url,
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('创建成功！')
          props.getFitnessSeriesData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <Modal
      destroyOnClose={true}
      title="添加健身系列"
      width='800px'
      open={props.isOpen}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key='cancel' onClick={handleCancel}>取消</Button>,
        <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
        <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
      ]}>

      <MyInput
        id="title"
        required
        autoFocus
        maxLength={64}
        label='健身系列标题'
        placeholder='请输入健身系列标题'
        value={formValue.title}
        onChange={setFormValue}
        errorMsg={errorMsg.titleEmpty}
      />

      <MyImageUpload
        id="cover_url"
        required
        label='健身系列封面'
        value={formValue.cover_url}
        setValue={setFormValue}
        errorMsg={errorMsg.coverEmpty}
      />

      <MyRichText
        id='introduction'
        required
        label='详细介绍'
        value={formValue.introduction}
        setValue={setFormValue}
        errorMsg={errorMsg.introductionEmpty}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default AddFitnessSeries
